module.exports = __webpack_public_path__ + "static/media/icon-emoji-awesome.fa7242f8.svg";